/*
 * Created on 07.02.2018
 *
 * Copyright(c) 1995 - 2018 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Component, Input } from '@angular/core';

/**
 * Diese Komponente generiert einen ausklappbaren Bereich innerhalb von Formularen.
 *
 * Usage:
 * <common-form-togglebox [title]="'Anmelden mit PIN'">
 *   <div class="form-group">
 *   <label for="pin">PIN *</label>
 *   <input  autocorrect="off" id="pin" name="pin" type="text" />
 *    </div>
 *    <p>Fordern Sie eine PIN an.</p>
 *    <div class="bnt d-block">
 *    <input id="requireNewPin" class="m-0"
 *    class="bnt__blue text-center" tabindex="40" value="Neue PIN anfordern" type="button">
 *  </div>
 *  </div>
 *       ...
 * </common-form-togglebox>
 *
 * @author Thomas Hamm (thm@mms-dresden.de)
 */
@Component({
    selector: 'common-form-togglebox',
    template: `
        <div class="form-group">
            <div class="toggleboxContainer">
                <div class="toggleboxHeader" (click)="toggleVisibility();">
                    <div class="toggleboxTitle">
                        <span class="icon-open" [ngClass]="{'icon-close': open,'icon-open': !open}"></span>
                        <span class="toggleboxTitleTxt">{{title}}</span>
                    </div>
                </div>
                <div class="togglebox" [ngClass]="{'showBox': open,'': !open}">
                    <div class="innerTogglebox">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class ToggleBoxComponent {

    @Input() title: string = '';

    open: boolean = false;

    toggleVisibility() {
        this.open = !this.open;
    }
}
